export const LogoMark = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <path
            d="M45 21.5a14.5 14.5 0 1 0 0 21"
            style={{ stroke: 'rgb(var(--bronze))' }}
            strokeWidth="4.5"
            strokeLinecap="round"
        />
        <path d="M29.5 19v26" style={{ stroke: 'rgb(var(--cream))' }} strokeWidth="4.5" strokeLinecap="round" />
        <path
            d="M29.5 19h7.5a7.5 7.5 0 0 1 0 15h-7.5"
            style={{ stroke: 'rgb(var(--cream))' }}
            strokeWidth="4.5"
            strokeLinejoin="round"
        />
    </svg>
);

export const BubbleLogo = ({ className = 'h-9' }) => (
    <svg viewBox="0 0 240 112" fill="none" className={className} role="img" aria-label="CommPro Worldwide">
        <rect x="7" y="8" width="226" height="62" rx="9" stroke="#FFFFFF" strokeWidth="4" />
        <path d="M192 62 L206 62 L199 83 Z" fill="#FFFFFF" />
        <text
            x="120"
            y="54"
            textAnchor="middle"
            fontFamily="Archivo, sans-serif"
            fontWeight="800"
            fontSize="36"
            letterSpacing="1"
            fill="#FFFFFF"
        >
            COMMPRO
        </text>
        <text
            x="16"
            y="99"
            fontFamily="'Plus Jakarta Sans', sans-serif"
            fontWeight="300"
            fontSize="13"
            letterSpacing="10"
            fill="#FFFFFF"
        >
            WORLDWIDE
        </text>
    </svg>
);

export const Logo = ({ compact = false }) => (
    <span className="flex items-center gap-3">
        <LogoMark size={compact ? 32 : 38} />
        <span className="leading-none">
            <span className="block font-serif text-lg sm:text-xl font-semibold tracking-tight text-cream">
                CommPro
            </span>
            <span className="block font-mono text-[9px] uppercase tracking-[0.35em] text-bronze mt-1">
                Worldwide
            </span>
        </span>
    </span>
);
